import React, { useEffect, useState } from "react";
import InputField from "../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../enums/InputFieldAttributesEnums";
import { ButtonShape, ButtonSize } from "../../enums/ButtonAttributesEnums";
import TNButton from "../../reusable-components/TNButton";
import styles from "./BidToolConfigurationView.module.scss";
import { Col, Modal, notification, Row } from "antd";
import {
  CancelStyles,
  SubmitStyles,
  BidConfigFormProps,
  stepThreeKeys,
  fieldUnitsConstants,
  fieldNames,
  bidToolResetModalConstants,
} from "./constants";
import { BidToolSettingsConfig } from "../../types/getSettingsBidConfigDataObject";
import { useFormContext } from "react-hook-form";
import { BidConfigPayloadFormatter } from "../../utils/bidConfigPayloadFormatter";
import BidToolConfigServices from "../../services/bidToolConfig.service";
const RunInformation: React.FC<TruckAssumptionsContentProps> = ({
  initialValues,
  currentTab,
  handleSaveOption,
  handleValidationErrors,
}) => {
  const {
    watch,
    setValue,
    trigger,
    clearErrors,
    handleSubmit,
    formState: { isValid, errors },
  } = useFormContext();
  const { SUBMIT_BTN_TXT, CANCEL_BTN_TXT, ROW_ALIGN } = BidConfigFormProps;
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const containerFields = initialValues?.data?.[0]?.runInformation;
  const currentFieldValues = watch();
  const payloadData = BidConfigPayloadFormatter({
    payloadData: currentFieldValues,
    id: initialValues?.data?.[0]?.id,
  });
  const { SubmitSettingsBidConfig } = BidToolConfigServices();
  const { mutateAsync: stepThreeSubmitMutate } = SubmitSettingsBidConfig();
  const handleStepThreeSubmit = async () => {
    await stepThreeSubmitMutate(payloadData, {
      onSuccess: () => {
        setIsSuccessOpen(true);
      },
    });
  };
  const handleBlur =
    (fieldName: string) => (event: React.FocusEvent<HTMLInputElement>) =>
      trigger(fieldName);
  const resetStepValues = () => {
    setValue(fieldNames.LOADING_TIME_CONFIG, containerFields?.[0]?.loading);
    setValue(fieldNames.UNLOADING_TIME_CONFIG, containerFields?.[1]?.unloading);
    setValue(
      fieldNames.DEADHEAD_FORWARD_TIME_CONFIG,
      containerFields?.[2]?.deadheadForwardTime
    );
    setValue(
      fieldNames.DEADHEAD_FORWARD_MILES_CONFIG,
      containerFields?.[3]?.deadheadForwardMile
    );
    setValue(
      fieldNames.DEADHEAD_BACKWARD_TIME_CONFIG,
      containerFields?.[4]?.deadheadBackwardTime
    );
    setValue(
      fieldNames.DEADHEAD_BACKWARD_MILES_CONFIG,
      containerFields?.[5]?.deadheadBackwardMile
    );
    setValue(
      fieldNames.TIME_BUFFER_CONFIG,
      containerFields?.[6]?.timeBufferSemi
    );
  };
  const handleOpenWarningModal = () => setIsWarningModalOpen(true);
  const handleCloseWarningModal = () => setIsWarningModalOpen(false);
  useEffect(() => {
    if (isSuccessOpen) {
      handleSaveOption(isSuccessOpen);
      setIsSuccessOpen(false);
    }
  }, [isSuccessOpen]);
  return (
    <>
      <Modal
        visible={isWarningModalOpen}
        onCancel={handleCloseWarningModal}
        title={bidToolResetModalConstants.TITLE_TEXT}
        okText={bidToolResetModalConstants.CONFIRM_TEXT}
        onOk={() => {
          resetStepValues();
          clearErrors(stepThreeKeys);
          notification.success({
            message: bidToolResetModalConstants.SUCCESS_MESSAGE,
          });
          handleCloseWarningModal();
        }}
      >
        <p style={bidToolResetModalConstants.MODAL_MESSAGE_STYLE}>
          {bidToolResetModalConstants.CONFIRM_MESSAGE}
        </p>
      </Modal>
      <div className={styles.TruckAssumptionWrapper}>
        <div className={styles.RunInfoContentContainer}>
          <Row>
            <Col span={20}>
              <div className={styles.outerRunInfoWrapper}>
                <Row align={ROW_ALIGN} className={styles.RowInputContainer}>
                  <Col span={10}>
                    <div>Loading (Time)</div>
                  </Col>
                  <Col span={14}>
                    <div className={styles.alignMinContainer}>
                      <InputField
                        customSmallErrorText
                        small
                        name={fieldNames.LOADING_TIME_CONFIG}
                        type={InputfieldTypes.TEXT}
                        onBlur={handleBlur(fieldNames.LOADING_TIME_CONFIG)}
                      />
                      <span className={styles.alignUnit}>
                        &nbsp;&nbsp;minutes
                      </span>
                    </div>
                  </Col>
                </Row>
                <Row align={ROW_ALIGN} className={styles.RowInputContainer}>
                  <Col span={10}>
                    <div>Unloading (Time)</div>
                  </Col>
                  <Col span={14}>
                    <div className={styles.alignMinContainer}>
                      <InputField
                        customSmallErrorText
                        small
                        name={fieldNames.UNLOADING_TIME_CONFIG}
                        type={InputfieldTypes.TEXT}
                        onBlur={handleBlur(fieldNames.UNLOADING_TIME_CONFIG)}
                      />
                      <span className={styles.alignUnit}>
                        &nbsp;&nbsp;minutes
                      </span>
                    </div>
                  </Col>
                </Row>
                <Row align={ROW_ALIGN} className={styles.RowInputContainer}>
                  <Col span={10}>
                    <div>Deadhead (F, Time)</div>
                  </Col>
                  <Col span={14}>
                    <div className={styles.alignMinContainer}>
                      <InputField
                        customSmallErrorText
                        small
                        name={fieldNames.DEADHEAD_FORWARD_TIME_CONFIG}
                        type={InputfieldTypes.TEXT}
                        onBlur={handleBlur(
                          fieldNames.DEADHEAD_FORWARD_TIME_CONFIG
                        )}
                      />
                      <span className={styles.alignUnit}>
                        &nbsp;&nbsp;minutes
                      </span>
                    </div>
                  </Col>
                </Row>
                <Row align={ROW_ALIGN} className={styles.RowInputContainer}>
                  <Col span={10}>
                    <div>Deadhead (F, Miles)</div>
                  </Col>
                  <Col span={14}>
                    <div className={styles.alignMinContainer}>
                      <InputField
                        customSmallErrorText
                        small
                        name={fieldNames.DEADHEAD_FORWARD_MILES_CONFIG}
                        type={InputfieldTypes.TEXT}
                        onBlur={handleBlur(
                          fieldNames.DEADHEAD_FORWARD_MILES_CONFIG
                        )}
                      />
                      <span className={styles.alignUnit}>
                        &nbsp;&nbsp;miles
                      </span>
                    </div>
                  </Col>
                </Row>
                <Row align={ROW_ALIGN} className={styles.RowInputContainer}>
                  <Col span={10}>
                    <div>Deadhead (B, Time)</div>
                  </Col>
                  <Col span={14}>
                    <div className={styles.alignMinContainer}>
                      <InputField
                        customSmallErrorText
                        small
                        name={fieldNames.DEADHEAD_BACKWARD_TIME_CONFIG}
                        type={InputfieldTypes.TEXT}
                        onBlur={handleBlur(
                          fieldNames.DEADHEAD_BACKWARD_TIME_CONFIG
                        )}
                      />
                      <span className={styles.alignUnit}>
                        &nbsp;&nbsp;minutes
                      </span>
                    </div>
                  </Col>
                </Row>
                <Row align={ROW_ALIGN} className={styles.RowInputContainer}>
                  <Col span={10}>
                    <div>Deadhead (B, Miles)</div>
                  </Col>
                  <Col span={14}>
                    <div className={styles.alignMinContainer}>
                      <InputField
                        customSmallErrorText
                        small
                        name={fieldNames.DEADHEAD_BACKWARD_MILES_CONFIG}
                        type={InputfieldTypes.TEXT}
                        onBlur={handleBlur(
                          fieldNames.DEADHEAD_BACKWARD_MILES_CONFIG
                        )}
                      />
                      <span className={styles.alignUnit}>
                        &nbsp;&nbsp;miles
                      </span>
                    </div>
                  </Col>
                </Row>
                <Row align={ROW_ALIGN} className={styles.RowInputContainer}>
                  <Col span={10}>
                    <div>Time Buffer, Semi</div>
                  </Col>
                  <Col span={14}>
                    <div className={styles.alignMinContainer}>
                      <InputField
                        customSmallErrorText
                        small
                        name={fieldNames.TIME_BUFFER_CONFIG}
                        type={InputfieldTypes.TEXT}
                        onBlur={handleBlur(fieldNames.TIME_BUFFER_CONFIG)}
                      />
                      <span className={styles.alignBufferUnit}>
                        &nbsp;&nbsp;{fieldUnitsConstants.TIME_BUFFER_UNIT}
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row className={styles.ButtonRow}>
            <Col span={24}>
              <div className={styles.buttonWrapper}>
                <TNButton
                  shape={ButtonShape.DEFAULT}
                  size={ButtonSize.LARGE}
                  text={CANCEL_BTN_TXT}
                  customStyles={CancelStyles}
                  onClick={handleOpenWarningModal}
                />
                <TNButton
                  shape={ButtonShape.DEFAULT}
                  size={ButtonSize.LARGE}
                  text={SUBMIT_BTN_TXT}
                  customStyles={SubmitStyles}
                  onClick={handleSubmit(
                    handleStepThreeSubmit,
                    handleValidationErrors
                  )}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
export default RunInformation;
